import React, { useMemo } from 'react';
import { defaultWidthHeightMap } from '../utils';
import { SupportedSVGS } from '../SupportedSVGs';
export const IconSVG = ({ iconType, style }) => {
    const RequestedSVG = SupportedSVGS[iconType];
    const height = useMemo(() => {
        var _a;
        if (style === null || style === void 0 ? void 0 : style.height) {
            return style.height;
        }
        return (_a = defaultWidthHeightMap.get(iconType)) === null || _a === void 0 ? void 0 : _a.height;
    }, [iconType, style]);
    const width = useMemo(() => {
        var _a;
        if (style === null || style === void 0 ? void 0 : style.width) {
            return style.width;
        }
        return (_a = defaultWidthHeightMap.get(iconType)) === null || _a === void 0 ? void 0 : _a.width;
    }, [iconType, style]);
    return (React.createElement("svg", { style: Object.assign(Object.assign({}, style), { height, width }) },
        React.createElement("use", { href: `${RequestedSVG}#icon` })));
};
//# sourceMappingURL=IconSVG.js.map